export default theme => ({
  dashboard_footer_copyright: {
    fontSize: 12,
    height: 40,
  },

  "dashboard_footer_copyright a": {
    fontSize: 12,
  },
});
